function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LayersComponent from '../../components/Layers/Layers';
import { toggleLayer as _toggleLayer } from '../../store/actions/mapSlice';

/**
 * This component is used to get the list of different types of map layers and manipulate them accordingly.
 */
var Layers = function Layers(props) {
  var dispatch = useDispatch();
  var group = props.group;
  var layers = [];
  var activeLayers = [];
  switch (group) {
    case 'secondary':
      layers = useSelector(function (state) {
        var _state$app;
        return state === null || state === void 0 ? void 0 : (_state$app = state.app) === null || _state$app === void 0 ? void 0 : _state$app.secondaryLayers;
      });
      activeLayers = useSelector(function (state) {
        var _state$app2, _state$app2$activeLay;
        return state === null || state === void 0 ? void 0 : (_state$app2 = state.app) === null || _state$app2 === void 0 ? void 0 : (_state$app2$activeLay = _state$app2.activeLayers) === null || _state$app2$activeLay === void 0 ? void 0 : _state$app2$activeLay.secondary;
      });
      break;
    case 'basemap':
      layers = useSelector(function (state) {
        var _state$app3;
        return state === null || state === void 0 ? void 0 : (_state$app3 = state.app) === null || _state$app3 === void 0 ? void 0 : _state$app3.basemaps;
      });
      activeLayers = useSelector(function (state) {
        var _state$app4, _state$app4$activeLay;
        return state === null || state === void 0 ? void 0 : (_state$app4 = state.app) === null || _state$app4 === void 0 ? void 0 : (_state$app4$activeLay = _state$app4.activeLayers) === null || _state$app4$activeLay === void 0 ? void 0 : _state$app4$activeLay.basemap;
      });
      break;
    case 'streetView':
      layers = useSelector(function (state) {
        var _state$app5;
        return state === null || state === void 0 ? void 0 : (_state$app5 = state.app) === null || _state$app5 === void 0 ? void 0 : _state$app5.streetViewLayers;
      });
      activeLayers = useSelector(function (state) {
        var _state$app6, _state$app6$activeLay;
        return state === null || state === void 0 ? void 0 : (_state$app6 = state.app) === null || _state$app6 === void 0 ? void 0 : (_state$app6$activeLay = _state$app6.activeLayers) === null || _state$app6$activeLay === void 0 ? void 0 : _state$app6$activeLay.streetView;
      });
      break;
  }
  return /*#__PURE__*/React.createElement(LayersComponent, _extends({
    layers: layers,
    activeLayers: activeLayers,
    toggleLayer: function toggleLayer(id, group) {
      return dispatch(_toggleLayer({
        id: id,
        group: group
      }));
    }
  }, props));
};
Layers.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The group type of layers to return. Should be one of predefined values  */
  group: PropTypes.oneOf(['secondary', 'basemap', 'streetView']).isRequired,
  /**
   * A render function that is used to display the a UI based on the provided data and methods.  Either the single function as a child this prop should be provided
   * @function
   * @param {Object} props
   * @param {Array} props.layers The list of all layers in the given group broken down by sections
   * @param {Array} props.activeLayers The list of layers in the given group that are currently active on the map
   * @param {Object} methods
   * @param {function} methods.toggleLayer A method to call when a given layer needs to be toggled on the map
   *  */
  render: PropTypes.func
} : {};
export default Layers;